module.exports = __webpack_public_path__ + "static/img/banner7.dab2919a.png";